module.exports = " <div class=\"hero-image__container {{$ctrl.AppServices.HeroManager.selectedGender}}\"> <svg class=svg width=102% viewBox=\"0 0 550 600\" xml:space=preserve></svg> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/hero-image/hero-image.html
 ** module id = 81
 ** module chunks = 0
 **/